import { useQuery } from '@tanstack/react-query';

import { getCasesOrchestrations, OrchestrationResponse } from 'api/experimentResults';
import useMainFilters from 'components/SearchFilters/hooks/useMainFilters';
import { ResultsMode } from 'interfaces/experimentResults';
import { Permission } from 'interfaces/permissionOption';
import { usePermissions } from 'utils/usePermissions';

export const useOrchestrations = ({
  studyId,
  resultsMode,
  onSuccess,
  enabled = true,
}: {
  studyId: string;
  resultsMode: ResultsMode;
  onSuccess?: (data: OrchestrationResponse) => void;
  enabled?: boolean;
}) => {
  const { hasPermission } = usePermissions();
  const canViewUnpublishedResults = hasPermission(Permission.ViewUnpublishedResults);
  const { isStudyIdSpecific } = useMainFilters();
  const studyIdIsSpecific = isStudyIdSpecific(studyId);

  return useQuery({
    queryKey: ['orchestrations', studyId, resultsMode],
    queryFn: () =>
      getCasesOrchestrations({
        filters: {
          studyId,
        },
        resultsMode: resultsMode,
        shouldOnlyGetByStudyIdAndResultsMode: true,
      }),
    enabled: enabled && studyIdIsSpecific && canViewUnpublishedResults,
    onSuccess,
  });
};
